export type StatusTone = "success" | "warning" | "danger";

// Single source of truth for HTTP status -> tone (2xx success, 4xx warning, 5xx danger).
export function statusTone(status: number): StatusTone {
  const bucket = Math.floor(status / 100);
  if (bucket === 2) return "success";
  if (bucket === 5) return "danger";
  return "warning";
}
